<template>
	<div class="flash_exchange_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{ $t('flashExchange.title') }}</div>
		</div>

		<div class="exchange_box">
			<!-- 卖出卡片 -->
			<div class="exchange_item sell">
				<div class="item_head">
					<span class="label">{{ $t('flashExchange.sell') }}</span>
					<span class="balance">{{ $t('flashExchange.available') }} {{ formatBalance(fromBalance) }} ETH</span>
				</div>
				<div class="input_row">
					<input
						v-model="fromAmount"
						type="number"
						:placeholder="$t('flashExchange.inputPlaceholder')"
						@input="calcToAmount"
					/>
					<div class="coin_tag">
						<span class="coin_icon eth">Ξ</span>
						<span class="coin_name">ETH</span>
					</div>
				</div>
				<div class="quick_btn" v-if="Number(fromBalance) > 0" @click="useAll">
					{{ $t('flashExchange.all') }}
				</div>
			</div>

			<!-- 中间箭头 -->
			<div class="exchange_icon">
				<div class="icon_circle">
					<van-icon name="arrow-down" />
				</div>
			</div>

			<!-- 获得卡片 -->
			<div class="exchange_item get">
				<div class="item_head">
					<span class="label">{{ $t('flashExchange.buy') }}</span>
					<span class="balance">{{ $t('flashExchange.estimated') }}</span>
				</div>
				<div class="input_row">
					<input
						v-model="toAmount"
						type="number"
						placeholder="0.00"
						readonly
					/>
					<div class="coin_tag">
						<span class="coin_icon usd">$</span>
						<span class="coin_name">USD</span>
					</div>
				</div>
			</div>

			<!-- 汇率信息 -->
			<div class="rate_info">
				<span class="rate_label">{{ $t('flashExchange.rate') }}</span>
				<span class="rate_value">
					<template v-if="rate">1 ETH ≈ {{ rate }} USD</template>
					<template v-else>{{ $t('flashExchange.loading') }}</template>
				</span>
			</div>

			<!-- 按钮 -->
			<div class="btn_wrap">
				<van-button
					type="primary"
					class="exchange_btn"
					:loading="loading"
					:disabled="!canSubmit"
					@click="submitExchange"
				>
					{{ $t('flashExchange.confirm') }}
				</van-button>
			</div>
		</div>
	</div>
</template>

<script>
import Fetch from '../../utils/fetch';

export default {
	name: 'flashexchange',
	data() {
		return {
			fromAmount: '',
			toAmount: '',
			rate: null,
			fromBalance: 0,
			loading: false
		};
	},
	computed: {
		canSubmit() {
			const amount = Number(this.fromAmount || 0);
			return this.rate && amount > 0 && amount <= Number(this.fromBalance);
		}
	},
	created() {
		this.getRate();
		this.getBalance();
	},
	methods: {
		formatBalance(v) {
			const n = Number(v || 0);
			if (!n) return '0';
			return n.toFixed(4).replace(/\.?0+$/, '');
		},
		useAll() {
			this.fromAmount = String(this.fromBalance);
			this.calcToAmount();
		},
		getRate() {
			Fetch('/exchange/rate', {
				from: 'ETH',
				to: 'USD'
			}).then(res => {
				this.rate = res.data.rate;
				this.calcToAmount();
			}).catch(() => {
				this.rate = null;
				this.$toast(this.$t('flashExchange.rateFail'));
			});
		},
		getBalance() {
			Fetch('/user/info').then(res => {
				this.fromBalance = res.data.eth_money || 0;
			});
		},
		calcToAmount() {
			const amount = Number(this.fromAmount || 0);
			if (!amount || !this.rate) {
				this.toAmount = '';
				return;
			}
			this.toAmount = (amount * this.rate).toFixed(2);
		},
		submitExchange() {
			if (!this.rate) {
				this.$toast(this.$t('flashExchange.rateNotReady'));
				return;
			}
			const amount = Number(this.fromAmount || 0);
			if (!amount || amount <= 0) {
				this.$toast(this.$t('flashExchange.inputAmount'));
				return;
			}
			if (amount > Number(this.fromBalance)) {
				this.$toast(this.$t('flashExchange.insufficient'));
				return;
			}

			this.loading = true;
			Fetch('/exchange/ethToUsd', {
				amount: amount
			}).then(res => {
				const receive = res && res.data && res.data.receive;
				this.$toast(
					receive
						? this.$t('flashExchange.success', { amount: receive })
						: this.$t('flashExchange.successSimple')
				);
				this.fromAmount = '';
				this.toAmount = '';
				this.getBalance();
			}).catch(err => {
				const msg = err && err.msg ? err.msg : this.$t('flashExchange.fail');
				this.$toast(typeof msg === 'object' ? msg[this.$i18n.locale] : msg);
			}).finally(() => {
				this.loading = false;
			});
		}
	}
};
</script>

<style lang="less" scoped>
.flash_exchange_wrap {
	min-height: 100vh;
	background: #f5f6fa;
	padding-bottom: 40px;
}

.exchange_box {
	width: 92%;
	margin: 20px auto 0;
}

.exchange_item {
	background: #fff;
	border-radius: 16px;
	padding: 20px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
	position: relative;

	.item_head {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 16px;

		.label {
			font-size: 14px;
			color: #666;
			font-weight: 500;
		}

		.balance {
			font-size: 12px;
			color: #999;
		}
	}

	.input_row {
		display: flex;
		align-items: center;
		gap: 12px;

		input {
			flex: 1;
			border: none;
			outline: none;
			font-size: 32px;
			font-weight: 600;
			color: #222;
			background: transparent;
			min-width: 0;

			&::placeholder {
				color: #ccc;
				font-weight: 400;
			}
		}

		.coin_tag {
			display: flex;
			align-items: center;
			gap: 6px;
			background: #f7f8fa;
			padding: 8px 14px;
			border-radius: 24px;
			flex-shrink: 0;

			.coin_icon {
				width: 24px;
				height: 24px;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 14px;
				font-weight: bold;
				color: #fff;

				&.eth {
					background: linear-gradient(135deg, #627eea, #3c5be0);
				}

				&.usd {
					background: linear-gradient(135deg, #26a17b, #1b8a65);
				}
			}

			.coin_name {
				font-size: 14px;
				font-weight: 600;
				color: #222;
			}
		}
	}

	.quick_btn {
		position: absolute;
		right: 20px;
		bottom: -25px;
		background: #222;
		color: #fff;
		font-size: 12px;
		padding: 4px 14px;
		border-radius: 12px;
		cursor: pointer;
		transition: opacity 0.2s;
		z-index: 3;

		&:active {
			opacity: 0.7;
		}
	}
}

.exchange_icon {
	display: flex;
	justify-content: center;
	align-items: center;
	margin: -6px 0;
	position: relative;
	z-index: 2;

	.icon_circle {
		width: 44px;
		height: 44px;
		border-radius: 50%;
		background: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
		color: #222;
		font-size: 20px;
		border: 4px solid #f5f6fa;
	}
}

.rate_info {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 16px 4px;
	margin-top: 8px;

	.rate_label {
		font-size: 13px;
		color: #999;
	}

	.rate_value {
		font-size: 13px;
		color: #222;
		font-weight: 500;
	}
}

.btn_wrap {
	display: flex;
	justify-content: center;
	margin-top: 30px;
}

.exchange_btn {
	width: 260px;
	height: 52px;
	border-radius: 26px;
	font-size: 17px;
	font-weight: 600;
	letter-spacing: 2px;
	text-indent: 2px;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	border: none;
	box-shadow: 0 8px 20px rgba(102, 126, 234, 0.35);
	transition: all 0.25s ease;
	display: flex;
	align-items: center;
	justify-content: center;

	&:active {
		transform: translateY(2px);
		box-shadow: 0 4px 10px rgba(102, 126, 234, 0.3);
	}

	&.van-button--disabled {
		background: linear-gradient(135deg, #d0d0d0, #b8b8b8);
		box-shadow: none;
		color: #fff;
		opacity: 0.7;
	}
}
</style>